module.exports = __webpack_public_path__ + "img/33.1.c84c395f.jpg";